import { render, staticRenderFns } from "./RestaurantCategoryUpsertDialog.vue?vue&type=template&id=efbe3eee"
import script from "./RestaurantCategoryUpsertDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantCategoryUpsertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports